// extracted by mini-css-extract-plugin
export default {"tooltip":"DayTooltip_tooltip__yUXER","tooltip__show":"DayTooltip_tooltip__show__qcXWA"};